/*jshint esversion: 6 */
import React from "react";
import Toaster from "toastr";
import Modal from "../../common/modal";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Constants from "../../../configurations/constants";
import SettlementsApi from "../../../api/SettlementsApi";
import Divider from "../../common/divider";
import SubHeader from "../../common/subHeader";
import SettlementTable from "./settlement/settlementTable";
import SettlementModalActions from "./modal/settlementModalAction";
import RenderObjects from "../../common/ObjectRenderer";
class SettlementRequestModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      requestReference: props.requestReference,
      cancelling: false,
      reason: "",
      data: props.settlementdata,
      actionState: "",
      settlements: props.settlements
    };

    this.modalStyle = {
      ovelay: {},
      content: {
        top: "80px",
        left: "250px",
        right: "250px",
        bottom: "100px",
        zIndex: "1000"
      }
    };
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  componentWillMount() {
    //Augment the properties
    let augmentedState = this.state.data;
    let augmentedActions = augmentedState.statusActions.map(item => {
      return {
        action: item,
        handler: this.handleAction
      };
    });
    augmentedState.statusActions = augmentedActions;

    this.setState({ data: augmentedState });
  }

  onTextInputChange(evt) {
    this.setState({
      reason: evt.target.value || ""
    });
  }
  handleAction(evt) {
    evt = evt.action;
    //evt = > State of the Button Action
    //if the reason is empty then we might really need one
    if (evt === Constants.SETTLEMENT_REQUEST_ACTION_CANCEL) {
      if (this.state.reason === "" || this.state.reason.length <= 2) {
        Toaster.warning(
          Messages.ERROR_SETTLEMENT_REASON_REQUIRED,
          `${Messages.ERROR_SETTLEMENT_REQUEST_CANCELED}`
        );
        return false;
      }
    }

    let reference = this.state.requestReference;
    this.setState({
      cancelling: true
    });

    let optionsData = {
      action: evt
    };

    if (
      evt === Constants.SETTLEMENT_REQUEST_ACTION_CANCEL &&
      this.state.reason !== null &&
      this.state.reason !== ""
    ) {
      optionsData.reason = this.state.reason;
    }

    SettlementsApi.processSettlementRequest(reference)
      .then(response => {
        Toaster.success(`The state has been updated`, `Action Successful`);
        this.props.onRequestClose(evt, true);
        this.setState({ cancelling: false });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          ` ${error.statusText}`,
          `${reference}`
        ]);
        this.setState({
          cancelling: false
        });
      });
  }

  render() {
    return (
      <Modal
        title={`${this.state.requestReference}`}
        isOpen={this.props.isOpen}
        style={this.modalStyle}
        onRequestClose={this.props.onRequestClose}
      >
        <div className="mod-content">
          <div>
            <Divider />
            <SubHeader title="Details" />
            <Divider />
            <div className="row">
              <div className="col-md-6 dispute-col">
                <div>
                  <label>Log Code:</label>
                  <label>{this.state.data.logCode || "-"}</label>
                </div>
                <div>
                  <label>Settlement Date:</label>
                  <label>{this.state.data.settlementDate || "-"}</label>
                </div>
                <div>
                  <label>Settlement Type:</label>
                  <label>{this.state.data.settlementType || "-"}</label>
                </div>

                <div>
                  <label>Settlement Store:</label>
                  <label>{this.state.data.settlementStore || "-"}</label>
                </div>

                <div>
                  <label>Amount Type:</label>
                  <label>{this.state.data.amountType || "-"}</label>
                </div>
                <div>
                  <label>Amount:</label>
                  <label>{this.state.data.amount || "-"}</label>
                </div>
              </div>
              <div className="col-md-6 dispute-col">
                <div>
                  <label>Status:</label>
                  <label>{this.state.data.status || "-"}</label>
                </div>

                <div>
                  <label>Created On:</label>
                  <label>{this.state.data.createdOn || "-"}</label>
                </div>

                <div>
                  <label>Last Updated On:</label>
                  <label>{this.state.data.lastUpdatedOn || "-"}</label>
                </div>
                <div>
                  <label>Status Message :</label>
                  {this.state.data.statusMessage && (
                    <RenderObjects
                      className="dispute-col"
                      objectToConv={this.state.data.statusMessage}
                    />
                  )}

                  {/* <textarea
                    readOnly="true"
                    style={{ width: "100%", height: "50px", fontSize: "12px" }}
                    value={
                      "statusMessage" in this.state.data
                        ? JSON.stringify(
                            this.state.data.statusMessage,
                            null,
                            2
                          ).replace(/^"|"$/gi, "")
                        : ""
                    }
                  /> */}
                </div>
                <div>
                  <label>Process Message :</label>
                  {this.state.data.processMessage && (
                    <RenderObjects
                      className="dispute-col"
                      objectToConv={this.state.data.processMessage}
                    />
                  )}

                  {/* <textarea
                    readOnly="true"
                    style={{ width: "100%", height: "50px", fontSize: "12px" }}
                    value={
                      "processMessage" in this.state.data
                        ? JSON.stringify(
                            this.state.data.processMessage,
                            null,
                            2
                          ).replace(/^"|"$/gi, "")
                        : ""
                    }
                  /> */}
                </div>
              </div>

              {this.state.settlements.length > 0 && (
                <div className="col-md-12">
                  <div>
                    <Divider />
                    <SubHeader title="Settlements" />
                    <Divider />
                    <SettlementTable
                      defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
                      settlements={this.state.settlements}
                      onTableChange={evt => null}
                      // defaultPageSize={5}
                    />
                  </div>
                </div>
              )}

              {this.state.data.statusActions.find(
                item =>
                  item.action === Constants.SETTLEMENT_REQUEST_ACTION_CANCEL
              ) !== undefined && (
                <div className="col-md-12">
                  <div>
                    <Divider />
                    <SubHeader title="Cancel Reason" />
                    <Divider />
                    <div className="dispute-comments">
                      <label>Reason:</label>
                      <br />
                      <textarea
                        id="reason"
                        required="true"
                        value={this.state.reason}
                        onChange={this.onTextInputChange}
                        placeholder="Enter reason for cancellation"
                        height="200px"
                        maxLength="500"
                        style={{ width: "100%" }}
                        className="ui-cool"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            className="mod-footer"
            style={{
              clear: "both",
              float: "right",
              width: "100%",
              textAlign: "right"
            }}
          >
            <SettlementModalActions
              actions={this.state.data.statusActions}
              hasCancel={true}
              cancelHandler={this.props.onRequestClose}
              disabled={this.state.cancelling}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default SettlementRequestModal;



// WEBPACK FOOTER //
// ./src/components/settlement/settlementRequests/settlementRequestModal.js